import { t } from './i18n.ts'
/** Human labels for every audit `action` the server emits (tests/unit/audit-labels.test.ts keeps this complete). */
export const ACTION_LABEL: Record<string, string> = {
  'ai.action_run': t('usou uma ação rápida do assistente'),
  'ai.byok_removed': t('removeu a chave própria de IA'),
  'ai.byok_set': t('configurou uma chave própria de IA'),
  'announcement.deleted': t('excluiu um aviso'),
  'announcement.published': t('publicou um aviso'),
  'announcement.updated': t('editou um aviso'),
  'area.created': t('cadastrou um espaço'),
  'area.updated': t('alterou um espaço'),
  'assembly.cancel': t('cancelou uma assembleia'),
  'assembly.close': t('encerrou a votação e apurou os resultados'),
  'assembly.created': t('criou uma assembleia'),
  'assembly.finalize': t('finalizou a ata de uma assembleia'),
  'assembly.open': t('abriu a votação de uma assembleia'),
  'assembly.proxy_set': t('registrou uma procuração'),
  'assembly.publish': t('convocou uma assembleia'),
  'assembly.updated': t('alterou uma assembleia'),
  'assembly.vote_cast': t('registrou um voto'),
  'auth.login': t('entrou no sistema'),
  'auth.review_login': t('entrou com a senha de avaliação'),
  'auth.review_login_failed': t('errou a senha de avaliação'),
  'auth.review_login_refused': t('teve a entrada de avaliação recusada (conta fora da demonstração)'),
  'auth.review_credential_issued': t('recebeu uma senha de avaliação do operador'),
  'auth.review_credential_revoked': t('teve a senha de avaliação revogada'),
  'auth.login_link': t('entrou com um link de acesso'),
  'auth.login_link_issued': t('recebeu um link de acesso do suporte'),
  'auth.logout_all': t('saiu de todos os aparelhos'),
  'condo.created': t('criou o condomínio'),
  'condo.dossie_generated': t('gerou o dossiê de transição'),
  'condo.export_downloaded': t('baixou a exportação dos dados'),
  'condo.export_requested': t('pediu a exportação dos dados'),
  'chat.member_muted': t('silenciou um membro no canal'),
  'chat.member_unmuted': t('liberou um membro no canal'),
  'chat.message_pinned': t('fixou uma mensagem no canal'),
  'chat.message_removed': t('removeu uma mensagem (moderação)'),
  'chat.message_reported': t('denunciou uma mensagem'),
  'chat.message_unpinned': t('desafixou uma mensagem do canal'),
  'chat.report_resolved': t('resolveu uma denúncia'),
  'chat.thread_closed': t('encerrou uma conversa'),
  'chat.thread_opened': t('abriu uma conversa'),
  'chat.thread_reopened': t('reabriu uma conversa'),
  'condo.brand_updated': t('alterou a marca do condomínio'),
  'condo.logo_removed': t('removeu o logo do condomínio'),
  'condo.logo_set': t('definiu o logo do condomínio'),
  'condo.updated': t('alterou as configurações'),
  'delivery.picked_up': t('registrou a retirada de uma encomenda'),
  'delivery.registered': t('registrou uma encomenda na portaria'),
  'display.created': t('criou uma tela (TV)'),
  'display.revoked': t('desativou uma tela (TV)'),
  'document.deleted': t('excluiu um documento'),
  'document.page_corrected': t('corrigiu o texto de uma página'),
  'document.signed': t('assinou um documento'),
  'document.signed_copy_attached': t('anexou a via assinada de um documento'),
  'document.summarized': t('gerou o resumo de um documento'),
  'document.updated': t('editou um documento'),
  'document.uploaded': t('enviou um documento'),
  'document.version_added': t('enviou uma nova versão de um documento'),
  'fact.created': t('adicionou uma informação ao manual do prédio'),
  'finance.entry_created': t('registrou um lançamento financeiro'),
  'finance.entry_deleted': t('excluiu um lançamento financeiro'),
  'finance.statement_added': t('adicionou um balancete'),
  'finance.statement_published': t('publicou um balancete aos moradores'),
  'folder.created': t('criou uma pasta'),
  'folder.deleted': t('excluiu uma pasta'),
  'invite.accepted': t('entrou no condomínio'),
  'invite.created': t('criou um convite'),
  'invite.revoked': t('revogou um convite'),
  'item.claimed': t('reconheceu um item como seu'),
  'item.reported': t('registrou um item em área comum'),
  'key.moved': t('registrou a retirada ou devolução de uma chave'),
  'member.account_deleted': t('excluiu a própria conta'),
  'member.left': t('saiu do condomínio'),
  'member.removed': t('removeu um membro'),
  'member.updated': t('alterou o papel de um membro'),
  'oauth.client_registered': t('um app de IA se registrou para conectar via OAuth'),
  'oauth.consent_granted': t('autorizou um app de IA a acessar seus condomínios (OAuth)'),
  'obligation.created': t('cadastrou uma obrigação'),
  'obligation.done': t('marcou uma obrigação como feita'),
  'obligation.updated': t('alterou uma obrigação'),
  'report.yearly_generated': t('gerou a prestação de contas anual'),
  'parecer.pdf_generated': t('gerou o PDF anual dos pareceres do conselho fiscal'),
  'parecer.signed': t('assinou um parecer do conselho fiscal'),
  'passkey.added': t('cadastrou uma chave de acesso (passkey)'),
  'passkey.removed': t('removeu uma chave de acesso (passkey)'),
  'pet.added': t('cadastrou um pet'),
  'pet.removed': t('removeu um pet do cadastro'),
  'platform.admin_added': t('virou operador da plataforma'),
  'platform.condo_partner_set': t('vinculou o condomínio a uma administradora (plataforma)'),
  'platform.condo_erase_scheduled': t('agendou a exclusão dos dados do condomínio (plataforma)'),
  'platform.condo_erased': t('excluiu os dados do condomínio (plataforma)'),
  'platform.condo_updated': t('alterou o plano ou a situação do condomínio (plataforma)'),
  'platform.partner_created': t('cadastrou uma administradora (plataforma)'),
  'platform.partner_updated': t('alterou uma administradora (plataforma)'),
  'platform.user_added': t('cadastrou uma conta pela linha de comando (plataforma)'),
  'poll.created': t('criou uma enquete'),
  'quote.created': t('abriu uma cotação'),
  'quote.decided': t('decidiu uma cotação'),
  'reading.added': t('registrou a leitura de um medidor'),
  'reading.removed': t('removeu a leitura de um medidor'),
  'renovation.decided': t('decidiu sobre uma reforma'),
  'renovation.requested': t('comunicou uma reforma'),
  'reservation.approved': t('aprovou uma reserva'),
  'reservation.cancelled': t('cancelou uma reserva'),
  'reservation.created': t('fez uma reserva'),
  'reservation.rejected': t('recusou uma reserva'),
  'supplier.created': t('cadastrou um fornecedor'),
  'supplier.updated': t('alterou um fornecedor'),
  'penalty.created': t('registrou um rascunho de advertência ou multa'),
  'penalty.updated': t('alterou um rascunho de advertência ou multa'),
  'penalty.notified': t('notificou uma unidade de advertência ou multa'),
  'penalty.defended': t('registrou a defesa de uma notificação'),
  'penalty.decided': t('decidiu uma notificação de advertência ou multa'),
  'penalty.appealed': t('recorreu à assembleia contra uma notificação de advertência ou multa'),
  'penalty.appeal_scheduled': t('incluiu o recurso de uma notificação na pauta de uma assembleia'),
  'penalty.appeal_decided': t('registrou a decisão da assembleia sobre o recurso de uma notificação'),
  'penalty.deleted': t('excluiu um rascunho de notificação'),
  'penalty.entry_created': t('lançou uma multa mantida como receita'),
  'budget.updated': t('atualizou a previsão orçamentária'),
  'budget.pdf_generated': t('gerou o PDF da previsão orçamentária'),
  'report.generated': t('gerou o relatório mensal'),
  'agenda.feed_created': t('gerou um endereço de assinatura da agenda'),
  'agenda.feed_revoked': t('revogou o endereço de assinatura da agenda'),
  'ticket.created': t('abriu um chamado'),
  'ticket.updated': t('atualizou um chamado'),
  'token.created': t('criou um token de acesso para assistentes de IA (MCP)'),
  'token.revoked': t('revogou um token de acesso (MCP)'),
  'unit.created': t('cadastrou unidades'),
  'unit.deleted': t('excluiu uma unidade'),
  'unit.people_set': t('vinculou pessoas a uma unidade'),
  'unit.updated': t('alterou uma unidade'),
  'units.import_discarded': t('descartou uma importação de unidades'),
  'units.import_requested': t('enviou uma lista para importar unidades'),
  'units.imported': t('importou unidades e convites de uma lista'),
  'user.created': t('criou a conta'),
  'portaria.log_added': t('registrou uma ocorrência no livro da portaria'),
  'portaria.log_seen': t('deu o visto em uma ocorrência da portaria'),
  'staff.created': t('cadastrou um funcionário'),
  'staff.deleted': t('apagou o cadastro de um funcionário'),
  'staff.dismissed': t('registrou o desligamento de um funcionário'),
  'staff.document_added': t('registrou um documento de funcionário nos prazos'),
  'staff.updated': t('atualizou o cadastro de um funcionário'),
  'user.deleted': t('excluiu a conta'),
  'user.email_bounced': t('teve o e-mail devolvido pelo provedor (endereço não recebe mensagens)'),
  'user.email_complained': t('marcou um aviso por e-mail como spam'),
  'user.email_removed': t('removeu o e-mail'),
  'user.email_requested': t('pediu a confirmação de um e-mail'),
  'user.email_verified': t('confirmou o e-mail'),
  'user.whatsapp_assistant_off': t('desativou o assistente pelo WhatsApp'),
  'user.whatsapp_assistant_on': t('ativou o assistente pelo WhatsApp'),
  'vehicle.added': t('cadastrou um veículo'),
  'vehicle.removed': t('removeu um veículo do cadastro'),
  'visitor.arrived': t('registrou a chegada de um visitante ou prestador'),
  'visitor.authorized': t('autorizou a entrada de um visitante ou prestador'),
  'visitor.cancelled': t('cancelou uma autorização de entrada'),
}

export const actionLabel = (action: string): string => ACTION_LABEL[action] ?? action
